import { useState } from 'react'
import { useAppSelector } from '../../../../hooks/redux'
import { NavLink } from 'react-router-dom'
import { Colors } from '../../../../constants/Colors'
import style from './NavBarItem.module.css'

interface Props {
    to: string,
    icon: string,
    title: string,
    count: number | null
}

const NavBarItem = ({to, icon, title, count}: Props) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <NavLink
            to={to}
            className={
                ({isActive}) => isActive
                    ? style.navItem + " " + style.active
                    : style.navItem
            }
            style={
                ({isActive}) => isActive
                ? {
                    color: Colors[theme].activeTint,
                    backgroundColor: Colors[theme].app
                }
                : isHover
                    ? {
                        fontSize: '1.5em',
                        color: Colors[theme].app,
                        backgroundColor: Colors[theme].inActiveTint
                    }
                    : {color: Colors[theme].text}
            }
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <span
                className={style.icon}
            >
                <i className={icon}></i>
            </span>
            <span
                className={style.title}
            >
                {title}
            </span>
            <span
                className={style.count}
            >
                {count}
            </span>
        </NavLink>
    )
}

export default NavBarItem
